module.exports = __webpack_public_path__ + "img/Indigo.3c220bf7.jpg";